
const navigation = document.getElementsByClassName('menu-main-wrapper')[0];
const menuToggle = document.getElementById('menu-toggle');

if (! _.isNil(menuToggle) && ! _.isNil(navigation)) {
    menuToggle.addEventListener( 'click', function() {
        if ( menuToggle.getAttribute( 'aria-expanded' ) === 'true' ) {
            menuToggle.setAttribute( 'aria-expanded', 'false' );
            document.body.classList.remove('main-menu-active')
            navigation.classList.remove( 'main-menu-open' );
        } else {
            menuToggle.setAttribute( 'aria-expanded', 'true' );
            document.body.classList.add('main-menu-active')
            navigation.classList.add( 'main-menu-open' );
        }
    } );

    document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape') {
            menuToggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('main-menu-active');
            navigation.classList.remove('main-menu-open')
        }
    });
}

if (! _.isNil(navigation)) {
    const subMenus = navigation.getElementsByClassName('menu-item--expanded');

    Array.from(subMenus).forEach(subMenu => {
        subMenu.addEventListener('click', (e) => {
            subMenu.classList.toggle('open');
        });
    });

    const subMenuAnchors = navigation.querySelectorAll('.menu-item--expanded > a');

    Array.from(subMenuAnchors).forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();
        })
    });
}
